class RGBA{
    constructor(red, green, blue, alpha) {
        if (typeof(alpha) === 'undefined'){
            alpha = 255;
        }
        else if (!Number.isInteger(alpha)){
            throw new TypeError('alpha must be an integer');
        }
        else if (alpha < 0 || alpha > 255){
            throw new Error('alpha must be between 0 and 255');
        }

        if (typeof(red) === 'undefined'){
            red = 0;
        }
        else if (!Number.isInteger(red)){
            throw new TypeError('red must be an integer');
        }
        else if (red < 0 || red > 255){
            throw new Error('red must be between 0 and 255');
        }

        if (typeof(green) === 'undefined'){
            green = 0;
        }
        else if (!Number.isInteger(green)){
            throw new TypeError('green must be an integer');
        }
        else if (green < 0 || green > 255){
            throw new Error('green must be between 0 and 255');
        }

        if (typeof(blue) === 'undefined'){
            blue = 0;
        }
        else if (!Number.isInteger(blue)){
            throw new TypeError('blue must be an integer');
        }
        else if (blue < 0 || blue > 255){
            throw new Error('blue must be between 0 and 255');
        }

        this.red = red;
        this.green = green;
        this.blue = blue;
        this.alpha = alpha;

        this.hex = `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
        this.rgba = `rgba(${red}, ${green}, ${blue}, ${alpha});`;
    }

    toHex(){
        return this.hex;
    }

    toRGBA(){
        return this.rgba;
    }

    toString(){
        return this.rgba;
    }
}

export default RGBA;